module.exports = __webpack_public_path__ + "static/media/Eventxtra Virtual Platform_v8-15.bad14a5c.png";